import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { apiFetch, parseJsonSafe, API_URL } from '../utils/api';
import WhatsappSettingsModal from '../components/settings/WhatsappSettingsModal';
import DolibarrSettingsModal from '../components/settings/DolibarrSettingsModal';
import EmailAccountsModal from '../components/settings/EmailAccountsModal';
import CalendarSettingsModal from '../components/settings/CalendarSettingsModal';
import EmailAccountEditorModal from '../components/settings/EmailAccountEditorModal';
import CompanySettingsModal from '../components/settings/CompanySettingsModal';
import StripeSettingsModal from '../components/settings/StripeSettingsModal';
import GoogleDriveSettingsModal from '../components/settings/GoogleDriveSettingsModal';
import ClaudeConnectorCard from '../components/settings/ClaudeConnectorCard';

const SettingsPage = () => {
  const token = localStorage.getItem('token');
  const [whatsModalOpen, setWhatsModalOpen] = useState(false);
  const [dolibarrModalOpen, setDolibarrModalOpen] = useState(false);
  const [calendarModalOpen, setCalendarModalOpen] = useState(false);
  const [driveModalOpen, setDriveModalOpen] = useState(false);
  const [driveStatus, setDriveStatus] = useState(null);
  const [loadingDrive, setLoadingDrive] = useState(false);
  const [savingDrive, setSavingDrive] = useState(false);
  const [testingDrive, setTestingDrive] = useState(false);
  const [driveConfig, setDriveConfig] = useState({
    connected: false,
    driveFolderId: '',
    account: null,
    storage: null,
    folder: null,
    folderError: null,
    error: null
  });
  const [emailModalOpen, setEmailModalOpen] = useState(false);
  const [returnToEmailModal, setReturnToEmailModal] = useState(false);
  const [wabaToken, setWabaToken] = useState('');
  const [phoneNumberId, setPhoneNumberId] = useState('');
  const [wabaStatus, setWabaStatus] = useState(null);
  const [wabaVerifyToken, setWabaVerifyToken] = useState('');
  const [wabaId, setWabaId] = useState('');
  const [autoReplyEnabled, setAutoReplyEnabled] = useState(false);
  const [aiGenerateDraft, setAiGenerateDraft] = useState(true);
  const [aiAutoSend, setAiAutoSend] = useState(false);
  const [autoReplyText, setAutoReplyText] = useState('Hemos recibido tu mensaje. En breve te respondemos.');
  const [autoReplyTemplateId, setAutoReplyTemplateId] = useState('');
  const [autoReplyTemplateType, setAutoReplyTemplateType] = useState('');
  const [autoReplyTemplateLang, setAutoReplyTemplateLang] = useState('es');
  // Anti-spam del saludo y aviso de fuera de horario con su horario comercial (L-V 10-19 por defecto)
  const [autoReplyOnceHours, setAutoReplyOnceHours] = useState(24);
  const [offHoursEnabled, setOffHoursEnabled] = useState(false);
  const [offHoursText, setOffHoursText] = useState('¡Gracias por escribirnos! Ahora mismo estamos fuera de nuestro horario de atención. Te respondemos en cuanto volvamos.');
  const [offHoursOnceHours, setOffHoursOnceHours] = useState(12);
  const [businessHours, setBusinessHours] = useState({
    timezone: 'Europe/Madrid',
    days: {
      1: [{ from: '10:00', to: '19:00' }],
      2: [{ from: '10:00', to: '19:00' }],
      3: [{ from: '10:00', to: '19:00' }],
      4: [{ from: '10:00', to: '19:00' }],
      5: [{ from: '10:00', to: '19:00' }],
      6: [],
      7: []
    }
  });
  const [whatsappTemplates, setWhatsappTemplates] = useState([]);
  const [dolibarrUrl, setDolibarrUrl] = useState('');
  const [dolibarrKey, setDolibarrKey] = useState('');
  const [doliStatus, setDoliStatus] = useState(null);
  const [dolibarrLoaded, setDolibarrLoaded] = useState(false);
  const [dolibarrLastSync, setDolibarrLastSync] = useState(null);
  const [loadingWhatsApp, setLoadingWhatsApp] = useState(false);
  const [loadingDolibarr, setLoadingDolibarr] = useState(false);
  const [stripeModalOpen, setStripeModalOpen] = useState(false);
  const [stripePublishableKey, setStripePublishableKey] = useState('');
  const [stripeSecretKey, setStripeSecretKey] = useState('');
  const [stripeWebhookSecret, setStripeWebhookSecret] = useState('');
  const [stripeHasSecretKey, setStripeHasSecretKey] = useState(false);
  const [stripeHasWebhookSecret, setStripeHasWebhookSecret] = useState(false);
  const [stripeStatus, setStripeStatus] = useState(null);
  const [loadingStripe, setLoadingStripe] = useState(false);
  const [emailAccounts, setEmailAccounts] = useState([]);
  const [emailStatus, setEmailStatus] = useState(null);
  const [calendarStatus, setCalendarStatus] = useState(null);
  const [calendarConfig, setCalendarConfig] = useState({
    enabled: false,
    calendarId: '',
    calendarIds: [],
    credentials: '',
    hasCredentials: false,
    workTimezone: 'Europe/Madrid',
    workMorningStart: '09:00',
    workMorningEnd: '13:00',
    workAfternoonStart: '15:00',
    workAfternoonEnd: '18:00',
    workDays: [1, 2, 3, 4, 5],
    connected: false
  });
  const [loadingAccounts, setLoadingAccounts] = useState(false);
  const [savingAccount, setSavingAccount] = useState(false);
  const [editingAccount, setEditingAccount] = useState(null);
  const [accountModalOpen, setAccountModalOpen] = useState(false);
  const [newCalendarId, setNewCalendarId] = useState('');
  const [companyModalOpen, setCompanyModalOpen] = useState(false);
  const DEFAULT_BRAND_PRIMARY = '#2563eb';
  const DEFAULT_BRAND_SECONDARY = '#0ea5e9';
  const [companyForm, setCompanyForm] = useState({
    name: '',
    cif: '',
    address: '',
    zip: '',
    city: '',
    province: '',
    country: '',
    logoUrl: '',
    brandPrimary: DEFAULT_BRAND_PRIMARY,
    brandSecondary: DEFAULT_BRAND_SECONDARY,
    bankAccount: ''
  });
  const [companyStatus, setCompanyStatus] = useState(null);
  const [savingCompany, setSavingCompany] = useState(false);
  const [uploadingLogo, setUploadingLogo] = useState(false);
  const signatureModules = React.useMemo(
    () => ({
      toolbar: [
        [{ header: [1, 2, 3, false] }],
        ['bold', 'italic', 'underline', 'strike'],
        [{ color: [] }, { background: [] }],
        [{ align: [] }],
        [{ list: 'ordered' }, { list: 'bullet' }],
        ['link', 'image'],
        ['clean']
      ]
    }),
    []
  );
  const signatureFormats = ['header', 'bold', 'italic', 'underline', 'strike', 'color', 'background', 'align', 'list', 'bullet', 'link', 'image', 'clean'];
  const [emailForm, setEmailForm] = useState({
    name: '',
    imap_host: '',
    imap_port: 993,
    imap_secure: true,
    imap_user: '',
    imap_password: '',
    smtp_host: '',
    smtp_port: 465,
    smtp_secure: true,
    smtp_user: '',
    smtp_password: '',
    from_name: '',
    from_email: '',
    inbox_folder: 'INBOX',
    signature: '',
    active: true
  });

  const alertVariant = (type) => {
    if (!type) return 'secondary';
    if (type === 'success') return 'success';
    if (type === 'info') return 'info';
    if (type === 'warning') return 'warning';
    if (type === 'error') return 'danger';
    return type;
  };
  const normalizeDriveImageUrl = (value) => {
    if (!value) return '';
    const raw = String(value);
    if (!raw.includes('drive.google.com') && !raw.includes('drive.usercontent.google.com')) return raw;
    const match = raw.match(/\/file\/d\/([^/]+)/) || raw.match(/[?&]id=([^&]+)/);
    if (!match) return raw;
    return `/api/uploads/drive/${match[1]}`;
  };
  const toAbsoluteUrl = (url) => {
    if (!url) return '';
    const normalized = normalizeDriveImageUrl(url);
    if (normalized.startsWith('http') || normalized.startsWith('//')) return normalized;
    if (API_URL) return `${API_URL}${normalized}`;
    try {
      return new URL(normalized, window.location.origin).toString();
    } catch (_e) {
      return normalized;
    }
  };

  const handleUnauthorized = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('role');
    localStorage.removeItem('userEmail');
    window.location.href = '/login';
  };

  const handleWhatsAppConnect = async (e) => {
    e.preventDefault();
    setWabaStatus(null);
    setLoadingWhatsApp(true);
    try {
      const res = await apiFetch('/api/integrations/whatsapp/connect', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ token: wabaToken, phoneNumberId, verifyToken: wabaVerifyToken, wabaId })
      });
      const data = await parseJsonSafe(res);
      if (res.status === 401) {
        return handleUnauthorized();
      }
      if (!res.ok) {
        throw new Error(data.message || 'No se pudo conectar con WhatsApp');
      }
      setWabaStatus({ type: 'success', message: data.message || 'Conectado con WhatsApp Business' });
    } catch (err) {
      setWabaStatus({ type: 'error', message: err.message });
    } finally {
      setLoadingWhatsApp(false);
    }
  };

  const loadDolibarrConfig = async () => {
    try {
      const res = await apiFetch('/api/integrations/dolibarr/config', {
        headers: { Authorization: `Bearer ${token}` }
      });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (!res.ok) throw new Error(data.message || 'No se pudo cargar la configuración');
      setDolibarrUrl(data.url || '');
      setDolibarrLastSync(data.lastSync);
      setDolibarrLoaded(true);
      if (data.hasApiKey) {
        setDoliStatus({ type: 'info', message: 'API Key guardada (no se muestra por seguridad)' });
      }
    } catch (err) {
      setDoliStatus({ type: 'error', message: err.message });
    }
  };

  const loadStripeConfig = async () => {
    try {
      const res = await apiFetch('/api/integrations/stripe/config', {
        headers: { Authorization: `Bearer ${token}` }
      });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (!res.ok) throw new Error(data.message || 'No se pudo cargar la configuración de Stripe');
      setStripePublishableKey(data.publishableKey || '');
      setStripeHasSecretKey(Boolean(data.hasSecretKey));
      setStripeHasWebhookSecret(Boolean(data.hasWebhookSecret));
      if (data.hasSecretKey || data.hasWebhookSecret) {
        setStripeStatus({ type: 'info', message: 'Credenciales guardadas (no se muestran por seguridad).' });
      }
    } catch (err) {
      setStripeStatus({ type: 'error', message: err.message });
    }
  };

  React.useEffect(() => {
    loadDolibarrConfig();
    loadStripeConfig();
    fetchEmailAccounts();
    loadWhatsAppConfig();
    loadWhatsAppTemplates();
    loadCalendarConfig();
    loadGoogleStatus();
    loadDriveStatus();
    fetchCompanyInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadWhatsAppTemplates = async () => {
    try {
      const res = await apiFetch('/api/whatsapp/templates', { headers: { Authorization: `Bearer ${token}` } });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (Array.isArray(data)) setWhatsappTemplates(data);
    } catch (err) {
      console.error('Error cargando plantillas WABA', err);
    }
  };

  const loadWhatsAppConfig = async () => {
    try {
      const res = await apiFetch('/api/integrations/whatsapp/config', {
        headers: { Authorization: `Bearer ${token}` }
      });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (!res.ok) throw new Error(data.message || 'No se pudo cargar la configuración de WhatsApp');
      if (data.hasToken) {
        setWabaStatus({ type: 'info', message: 'Token guardado (no se muestra por seguridad)' });
      }
      if (data.phoneNumberId) {
        setPhoneNumberId(data.phoneNumberId);
      }
      if (data.wabaId) setWabaId(data.wabaId);
      if (data.verifyToken) setWabaVerifyToken(data.verifyToken);
      setAutoReplyEnabled(Boolean(data.autoReplyEnabled));
      if (data.autoReplyText) setAutoReplyText(data.autoReplyText);
      if (data.autoReplyTemplate?.id) {
        setAutoReplyTemplateId(data.autoReplyTemplate.id);
        setAutoReplyTemplateType(data.autoReplyTemplate.type || '');
        setAutoReplyTemplateLang(data.autoReplyTemplate.lang || 'es');
      }
      if (Number.isFinite(Number(data.autoReplyOnceHours))) setAutoReplyOnceHours(Number(data.autoReplyOnceHours));
      if (data.offHours) {
        setOffHoursEnabled(Boolean(data.offHours.enabled));
        if (data.offHours.text) setOffHoursText(data.offHours.text);
        if (Number.isFinite(Number(data.offHours.onceHours))) setOffHoursOnceHours(Number(data.offHours.onceHours));
        if (data.offHours.businessHours?.days) setBusinessHours(data.offHours.businessHours);
      }
    } catch (err) {
      setWabaStatus({ type: 'error', message: err.message });
    }
  };

  const handleDolibarrConnect = async (e) => {
    e.preventDefault();
    setDoliStatus(null);
    setLoadingDolibarr(true);
    try {
      const res = await apiFetch('/api/integrations/dolibarr/connect', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ url: dolibarrUrl, apiKey: dolibarrKey })
      });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (!res.ok) {
        throw new Error(data.message || 'No se pudo conectar con Dolibarr');
      }
      setDoliStatus({ type: 'success', message: data.message || 'Credenciales de Dolibarr guardadas' });
      loadDolibarrConfig();
    } catch (err) {
      setDoliStatus({ type: 'error', message: err.message });
    } finally {
      setLoadingDolibarr(false);
    }
  };

  const handleStripeSave = async (e) => {
    e.preventDefault();
    setStripeStatus(null);
    setLoadingStripe(true);
    try {
      const payload = {
        publishableKey: stripePublishableKey,
        secretKey: stripeSecretKey || undefined,
        webhookSecret: stripeWebhookSecret || undefined
      };
      const res = await apiFetch('/api/integrations/stripe/config', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(payload)
      });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (!res.ok) throw new Error(data.message || 'No se pudo guardar la configuración de Stripe');
      setStripeHasSecretKey(Boolean(data.hasSecretKey));
      setStripeHasWebhookSecret(Boolean(data.hasWebhookSecret));
      setStripeSecretKey('');
      setStripeWebhookSecret('');
      setStripeStatus({ type: 'success', message: 'Configuración de Stripe guardada' });
    } catch (err) {
      setStripeStatus({ type: 'error', message: err.message });
    } finally {
      setLoadingStripe(false);
    }
  };

  const fetchCompanyInfo = async () => {
    try {
      const res = await apiFetch('/api/company', { headers: { Authorization: `Bearer ${token}` } });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (res.ok && data) {
        setCompanyForm({
          name: data.company_name || data.name || '',
          cif: data.company_cif || data.cif || '',
          address: data.company_address || data.address || '',
          zip: data.company_zip || data.zip || '',
          city: data.company_city || data.city || '',
          province: data.company_province || data.province || '',
          country: data.company_country || data.country || '',
          logoUrl: data.company_logo_url || data.logoUrl || '',
          brandPrimary: data.company_brand_primary || data.brandPrimary || DEFAULT_BRAND_PRIMARY,
          brandSecondary: data.company_brand_secondary || data.brandSecondary || DEFAULT_BRAND_SECONDARY,
          bankAccount: data.company_bank_account || data.bankAccount || ''
        });
      }
    } catch (err) {
      console.error('Error cargando datos de empresa', err);
    }
  };

  const handleSaveCompany = async () => {
    setSavingCompany(true);
    setCompanyStatus(null);
    try {
      const res = await apiFetch('/api/company', {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify(companyForm)
      });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (!res.ok) throw new Error(data.message || 'No se pudo guardar');
      setCompanyStatus({ type: 'success', message: 'Datos de empresa guardados' });
      setCompanyForm((prev) => ({
        ...prev,
        name: data.company_name || data.name || prev.name,
        cif: data.company_cif || data.cif || prev.cif,
        address: data.company_address || data.address || prev.address,
        zip: data.company_zip || data.zip || prev.zip,
        city: data.company_city || data.city || prev.city,
        province: data.company_province || data.province || prev.province,
        country: data.company_country || data.country || prev.country,
        logoUrl: data.company_logo_url || data.logoUrl || prev.logoUrl,
        brandPrimary: data.company_brand_primary || data.brandPrimary || prev.brandPrimary,
        brandSecondary: data.company_brand_secondary || data.brandSecondary || prev.brandSecondary,
        bankAccount: data.company_bank_account || data.bankAccount || prev.bankAccount
      }));
    } catch (err) {
      setCompanyStatus({ type: 'error', message: err.message });
    } finally {
      setSavingCompany(false);
    }
  };

  const handleUploadLogo = async (file) => {
    if (!file) return;
    const formData = new FormData();
    formData.append('file', file);
    try {
      setUploadingLogo(true);
      const res = await apiFetch('/api/uploads/images', {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
        body: formData
      });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (!res.ok) throw new Error(data.message || 'No se pudo subir el logotipo');
      setCompanyForm((prev) => ({ ...prev, logoUrl: data.url || '' }));
      setCompanyStatus({ type: 'success', message: 'Logotipo subido' });
    } catch (err) {
      setCompanyStatus({ type: 'error', message: err.message });
    } finally {
      setUploadingLogo(false);
    }
  };

  const loadCalendarConfig = async () => {
    try {
      const res = await apiFetch('/api/integrations/email-poll-config', {
        headers: { Authorization: `Bearer ${token}` }
      });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (!res.ok) throw new Error(data.message || 'No se pudo cargar configuración de calendario');
      setCalendarConfig((prev) => ({
        ...prev,
        enabled: data.calendarEnabled ?? prev.enabled,
        calendarId: data.calendarId || '',
        calendarIds: Array.isArray(data.calendarIds) ? data.calendarIds : [],
        hasCredentials: data.hasCalendarCredentials || false,
        workTimezone: data.workTimezone || 'Europe/Madrid',
        workMorningStart: data.workMorningStart || '09:00',
        workMorningEnd: data.workMorningEnd || '13:00',
        workAfternoonStart: data.workAfternoonStart || '15:00',
        workAfternoonEnd: data.workAfternoonEnd || '18:00',
        workDays: Array.isArray(data.workDays) && data.workDays.length ? data.workDays : [1, 2, 3, 4, 5]
      }));
    } catch (err) {
      setCalendarStatus({ type: 'error', message: err.message });
    }
  };

  const loadGoogleStatus = async () => {
    try {
      const res = await apiFetch('/api/integrations/google/status', { headers: { Authorization: `Bearer ${token}` } });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (res.status === 404) {
        // si aún no está disponible la ruta, no mostramos alerta
        return;
      }
      if (!res.ok) throw new Error(data.message || 'No se pudo cargar estado de Google');
      setCalendarConfig((prev) => ({
        ...prev,
        connected: data.connected || false,
        calendarId: data.calendarId || prev.calendarId
      }));
    } catch (err) {
      setCalendarStatus({ type: 'error', message: err.message });
    }
  };

  const loadDriveStatus = async () => {
    setLoadingDrive(true);
    try {
      const res = await apiFetch('/api/integrations/google/drive/status', { headers: { Authorization: `Bearer ${token}` } });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (!res.ok) throw new Error(data.message || 'No se pudo cargar estado de Google Drive');
      setDriveConfig((prev) => ({
        ...prev,
        connected: data.connected || false,
        driveFolderId: data.driveFolderId || '',
        account: data.account || null,
        storage: data.storage || null,
        folder: data.folder || null,
        folderError: data.folderError || null,
        error: data.error || null
      }));
    } catch (err) {
      setDriveStatus({ type: 'error', message: err.message });
    } finally {
      setLoadingDrive(false);
    }
  };

  const handleSaveDrive = async (e) => {
    e.preventDefault();
    setDriveStatus(null);
    setSavingDrive(true);
    try {
      const res = await apiFetch('/api/integrations/google/drive/config', {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ driveFolderId: driveConfig.driveFolderId || '' })
      });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (!res.ok) throw new Error(data.message || 'No se pudo guardar la configuración de Google Drive');
      setDriveStatus({ type: 'success', message: 'Configuración de Google Drive guardada' });
      setDriveConfig((prev) => ({ ...prev, driveFolderId: data.driveFolderId || '' }));
      await loadDriveStatus();
    } catch (err) {
      setDriveStatus({ type: 'error', message: err.message });
    } finally {
      setSavingDrive(false);
    }
  };

  const handleTestDrive = async () => {
    setDriveStatus(null);
    setTestingDrive(true);
    try {
      const res = await apiFetch('/api/integrations/google/drive/test', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ driveFolderId: driveConfig.driveFolderId || '' })
      });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (!res.ok) throw new Error(data.message || 'No se pudo conectar con Google Drive');
      setDriveConfig((prev) => ({
        ...prev,
        connected: true,
        account: data.account || prev.account,
        storage: data.storage || prev.storage,
        folder: data.folder || null,
        folderError: data.folderError || null,
        error: null
      }));
      if (data.ok) {
        const where = data.folder ? `carpeta "${data.folder.name}"` : 'raíz de Mi unidad';
        setDriveStatus({ type: 'success', message: `Conexión correcta con ${data.account?.email || 'Google Drive'} (${where}).` });
      } else {
        setDriveStatus({ type: 'error', message: data.folderError || 'La carpeta configurada no es accesible' });
      }
    } catch (err) {
      setDriveStatus({ type: 'error', message: err.message });
    } finally {
      setTestingDrive(false);
    }
  };

  const handleDriveConnect = async () => {
    setDriveStatus(null);
    try {
      const res = await apiFetch('/api/integrations/google/oauth/start', {
        headers: { Authorization: `Bearer ${token}` }
      });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (!res.ok || !data.url) throw new Error(data.message || 'No se pudo iniciar OAuth');
      window.location.href = data.url;
    } catch (err) {
      setDriveStatus({ type: 'error', message: err.message });
    }
  };

  const fetchEmailAccounts = async () => {
    setLoadingAccounts(true);
    setEmailStatus(null);
    try {
      const res = await apiFetch('/api/email-accounts', { headers: { Authorization: `Bearer ${token}` } });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (!res.ok) throw new Error(data.message || 'Error cargando cuentas');
      setEmailAccounts(Array.isArray(data) ? data : []);
    } catch (err) {
      setEmailStatus({ type: 'error', message: err.message });
    } finally {
      setLoadingAccounts(false);
    }
  };

  const resetEmailForm = () => {
    setEditingAccount(null);
    setEmailForm({
      name: '',
      imap_host: '',
      imap_port: 993,
      imap_secure: true,
      imap_user: '',
      imap_password: '',
      smtp_host: '',
      smtp_port: 465,
      smtp_secure: true,
      smtp_user: '',
      smtp_password: '',
      from_name: '',
      from_email: '',
      inbox_folder: 'INBOX',
      signature: '',
      active: true
    });
    setAccountModalOpen(false);
  };

  const openAccountEditorFromEmailModal = (openFn) => {
    setEmailModalOpen(false);
    setReturnToEmailModal(true);
    openFn();
  };

  const closeAccountEditor = () => {
    resetEmailForm();
    if (returnToEmailModal) {
      setEmailModalOpen(true);
      setReturnToEmailModal(false);
    }
  };

  const handleEditAccount = (acc) => {
    setEditingAccount(acc);
    setEmailForm({
      name: acc.name || '',
      imap_host: acc.imap_host || '',
      imap_port: acc.imap_port || 993,
      imap_secure: acc.imap_secure ?? true,
      imap_user: acc.imap_user || '',
      imap_password: '',
      smtp_host: acc.smtp_host || '',
      smtp_port: acc.smtp_port || 465,
      smtp_secure: acc.smtp_secure ?? true,
      smtp_user: acc.smtp_user || '',
      smtp_password: '',
      from_name: acc.from_name || '',
      from_email: acc.from_email || '',
      inbox_folder: acc.inbox_folder || 'INBOX',
      signature: acc.signature || '',
      active: acc.active ?? true
    });
    setAccountModalOpen(true);
  };

  const handleEmailFormChange = (e) => {
    const { name, value, type, checked } = e.target;
    setEmailForm((prev) => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
  };

  const handleAddCalendarId = () => {
    const value = newCalendarId.trim();
    if (!value) return;
    setCalendarConfig((prev) => {
      if (prev.calendarId === value || prev.calendarIds.includes(value)) return prev;
      return { ...prev, calendarIds: [...prev.calendarIds, value] };
    });
    setNewCalendarId('');
  };

  const handleRemoveCalendarId = (value) => {
    setCalendarConfig((prev) => ({
      ...prev,
      calendarIds: prev.calendarIds.filter((id) => id !== value)
    }));
  };

  const handleSaveCalendar = async (e) => {
    e.preventDefault();
    setCalendarStatus(null);
    try {
      const payload = {
        calendarEnabled: calendarConfig.enabled,
        calendarId: calendarConfig.calendarId,
        calendarIds: calendarConfig.calendarIds,
        workTimezone: calendarConfig.workTimezone,
        workMorningStart: calendarConfig.workMorningStart,
        workMorningEnd: calendarConfig.workMorningEnd,
        workAfternoonStart: calendarConfig.workAfternoonStart,
        workAfternoonEnd: calendarConfig.workAfternoonEnd,
        workDays: calendarConfig.workDays
      };
      if (calendarConfig.credentials) {
        payload.calendarCredentials = calendarConfig.credentials;
      }
      const res = await apiFetch('/api/integrations/email-poll-config', {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify(payload)
      });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (!res.ok) throw new Error(data.message || 'No se pudo guardar configuración de calendario');
      setCalendarStatus({ type: 'success', message: 'Calendario guardado' });
      setCalendarConfig((prev) => ({
        ...prev,
        calendarIds: Array.isArray(data.calendarIds) ? data.calendarIds : prev.calendarIds,
        calendarId: data.calendarId || prev.calendarId,
        hasCredentials: data.hasCalendarCredentials || prev.hasCredentials,
        credentials: '' // limpiamos para no mostrar clave
      }));
    } catch (err) {
      setCalendarStatus({ type: 'error', message: err.message });
    }
  };

  const handleGoogleConnect = async () => {
    setCalendarStatus(null);
    try {
      const res = await apiFetch('/api/integrations/google/oauth/start', {
        headers: { Authorization: `Bearer ${token}` }
      });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (!res.ok || !data.url) throw new Error(data.message || 'No se pudo iniciar OAuth');
      window.location.href = data.url;
    } catch (err) {
      setCalendarStatus({ type: 'error', message: err.message });
    }
  };

  const loadWhatsappAiConfig = async () => {
    try {
      const res = await apiFetch('/api/whatsapp/ai-config', { headers: { Authorization: `Bearer ${token}` } });
      const data = await parseJsonSafe(res);
      if (res.ok) {
        setAiGenerateDraft(data.generateDraft !== false);
        setAiAutoSend(data.autoSend === true);
      }
    } catch (_) { /* noop */ }
  };

  const handleSaveAiConfig = async () => {
    setWabaStatus(null);
    try {
      const res = await apiFetch('/api/whatsapp/ai-config', {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ generateDraft: aiGenerateDraft, autoSend: aiAutoSend })
      });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (!res.ok) throw new Error(data.message || 'No se pudo guardar la configuración IA');
      setWabaStatus({ type: 'success', message: 'Ajustes de IA guardados' });
    } catch (err) {
      setWabaStatus({ type: 'error', message: err.message });
    }
  };

  const handleSaveAutoReply = async () => {
    setWabaStatus(null);
    try {
      const res = await apiFetch('/api/integrations/whatsapp/auto-reply', {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({
          enabled: autoReplyEnabled,
          text: autoReplyText,
          onceHours: Number(autoReplyOnceHours),
          template: autoReplyTemplateId
            ? { id: autoReplyTemplateId, type: autoReplyTemplateType, lang: autoReplyTemplateLang }
            : null
        })
      });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (!res.ok) throw new Error(data.message || 'No se pudo guardar la auto-respuesta');
      setWabaStatus({ type: 'success', message: 'Respuesta automática guardada' });
    } catch (err) {
      setWabaStatus({ type: 'error', message: err.message });
    }
  };

  const handleSaveOffHours = async () => {
    setWabaStatus(null);
    try {
      const res = await apiFetch('/api/integrations/whatsapp/off-hours', {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({
          enabled: offHoursEnabled,
          text: offHoursText,
          onceHours: Number(offHoursOnceHours),
          businessHours
        })
      });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (!res.ok) throw new Error(data.message || 'No se pudo guardar el horario');
      if (data.businessHours?.days) setBusinessHours(data.businessHours);
      setWabaStatus({ type: 'success', message: `Horario guardado${data.resumen ? `: ${data.resumen}` : ''}` });
    } catch (err) {
      setWabaStatus({ type: 'error', message: err.message });
    }
  };

  const handleSaveAccount = async (e) => {
    e.preventDefault();
    setSavingAccount(true);
    setEmailStatus(null);
    try {
      const payload = { ...emailForm };
      if (!payload.imap_password) delete payload.imap_password;
      if (!payload.smtp_password) delete payload.smtp_password;
      const isEdit = Boolean(editingAccount && editingAccount.id);
      const url = isEdit ? `/api/email-accounts/${editingAccount.id}` : '/api/email-accounts';
      const method = isEdit ? 'PUT' : 'POST';
      const res = await apiFetch(url, {
        method,
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify(payload)
      });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (!res.ok) throw new Error(data.message || 'Error guardando cuenta');
      setEmailStatus({ type: 'success', message: isEdit ? 'Cuenta actualizada' : 'Cuenta creada' });
      resetEmailForm();
      fetchEmailAccounts();
      setAccountModalOpen(false);
      if (returnToEmailModal) {
        setEmailModalOpen(true);
        setReturnToEmailModal(false);
      }
    } catch (err) {
      setEmailStatus({ type: 'error', message: err.message });
    } finally {
      setSavingAccount(false);
    }
  };

  return (
    <>
      <div>
        <div className="d-flex justify-content-between align-items-center mb-2">
          <div>
            <h2 className="mb-0">Configuración</h2>
            <p className="mb-0">Conecta tus integraciones clave desde este panel.</p>
          </div>
        <Link to="/logs-ia" className="btn btn-outline-primary btn-sm">Logs IA</Link>
      </div>

      <div className="row g-4">
        <div className="col-12 col-lg-6">
          <div className="card shadow-sm h-100">
            <div className="card-body d-flex flex-column">
              <h5 className="card-title">Empresa</h5>
              <p className="card-text text-muted small flex-grow-1">Datos fiscales y logotipo para presupuestos y comunicaciones.</p>
              <div className="small text-muted mb-2">Razón social: {companyForm.name || 'No configurada'}</div>
              {companyForm.logoUrl && (
                <div className="mb-2">
                  <div className="small text-muted">Logotipo actual:</div>
                  <img src={toAbsoluteUrl(companyForm.logoUrl)} alt="Logotipo" style={{ maxHeight: 60 }} />
                </div>
              )}
              <button className="btn btn-primary mt-auto" onClick={() => setCompanyModalOpen(true)}>Abrir configuración</button>
            </div>
          </div>
        </div>
        <div className="col-12 col-lg-6">
          <div className="card shadow-sm h-100">
            <div className="card-body d-flex flex-column">
              <h5 className="card-title">WhatsApp Business</h5>
              <p className="card-text text-muted small flex-grow-1">Token, phone number ID y respuestas automáticas.</p>
              {wabaStatus && (
                <div className={`alert alert-${alertVariant(wabaStatus.type)} py-2`}>
                  {wabaStatus.message}
                </div>
              )}
              <button className="btn btn-primary mt-auto" onClick={() => { setWhatsModalOpen(true); loadWhatsappAiConfig(); }}>Abrir configuración</button>
            </div>
          </div>
        </div>

        <div className="col-12 col-lg-6">
          <div className="card shadow-sm h-100">
            <div className="card-body">
              <h5 className="card-title">Dolibarr</h5>
              <p className="card-text text-muted small">URL y API Key para sincronizar clientes, facturas y presupuestos.</p>
              {dolibarrLastSync && <div className="alert alert-info py-2 mb-2">Última sincronización: {new Date(dolibarrLastSync).toLocaleString()}</div>}
              {doliStatus && (
                <div className={`alert alert-${alertVariant(doliStatus.type)} py-2 mb-0`}>
                  {doliStatus.message}
                </div>
              )}
              <button className="btn btn-primary mt-3" onClick={() => setDolibarrModalOpen(true)}>Abrir configuración</button>
            </div>
          </div>
        </div>

        <div className="col-12 col-lg-6">
          <div className="card shadow-sm h-100">
            <div className="card-body d-flex flex-column">
              <h5 className="card-title">Stripe</h5>
              <p className="card-text text-muted small flex-grow-1">Claves para habilitar el pago con tarjeta en facturas.</p>
              {stripeStatus && (
                <div className={`alert alert-${alertVariant(stripeStatus.type)} py-2`}>
                  {stripeStatus.message}
                </div>
              )}
              <button className="btn btn-primary mt-auto" onClick={() => setStripeModalOpen(true)}>Abrir configuración</button>
            </div>
          </div>
        </div>
      </div>

      <div className="card shadow-sm mt-4">
        <div className="card-body d-flex flex-column">
          <h5 className="card-title">Cuentas de email</h5>
          <p className="card-text text-muted small">Credenciales IMAP/SMTP y firmas.</p>
          <div className="d-flex justify-content-between align-items-center mb-2">
            <div className="text-muted small">{loadingAccounts ? 'Cargando cuentas...' : `${emailAccounts.length} cuentas configuradas`}</div>
            <button className="btn btn-primary btn-sm" onClick={() => setEmailModalOpen(true)}>Gestionar</button>
          </div>
          {emailStatus && (
            <div className={`alert alert-${alertVariant(emailStatus.type)} py-2 mb-0`}>
              {emailStatus.message}
            </div>
          )}
        </div>
      </div>

      <div className="card shadow-sm mt-4">
        <div className="card-body d-flex flex-column">
          <h5 className="card-title">Google Calendar y agenda</h5>
          <p className="card-text text-muted small">OAuth, calendarios adicionales y rangos laborales.</p>
          {calendarStatus && (
            <div className={`alert alert-${alertVariant(calendarStatus.type)} py-2 mb-0`}>
              {calendarStatus.message}
            </div>
          )}
          <button className="btn btn-primary mt-2" onClick={() => setCalendarModalOpen(true)}>Abrir configuración</button>
        </div>
      </div>

      <div className="card shadow-sm mt-4">
        <div className="card-body d-flex flex-column">
          <h5 className="card-title">Google Drive</h5>
          <p className="card-text text-muted small">Almacenamiento de adjuntos e imágenes: OAuth y carpeta raíz.</p>
          <div className="small text-muted mb-2">
            Estado:{' '}
            {loadingDrive ? 'Comprobando...' : driveConfig.connected ? (
              <span className="text-success">Conectado{driveConfig.account?.email ? ` (${driveConfig.account.email})` : ''}</span>
            ) : (
              <span className="text-danger">No conectado</span>
            )}
            {driveConfig.connected && (
              <>
                {' · '}Carpeta: {driveConfig.folder ? driveConfig.folder.name : (driveConfig.driveFolderId ? driveConfig.driveFolderId : 'Raíz de Mi unidad')}
              </>
            )}
          </div>
          {driveConfig.folderError && (
            <div className="alert alert-warning py-2 mb-2">{driveConfig.folderError}</div>
          )}
          {driveStatus && (
            <div className={`alert alert-${alertVariant(driveStatus.type)} py-2 mb-0`}>
              {driveStatus.message}
            </div>
          )}
          <button className="btn btn-primary mt-2" onClick={() => { setDriveStatus(null); setDriveModalOpen(true); }}>Abrir configuración</button>
        </div>
      </div>

      <ClaudeConnectorCard token={token} />
      <div className="card shadow-sm mt-4"><div className="card-body">
        <h5 className="card-title">Conexiones Google</h5>
        <p className="text-muted small">Merchant Center, Google Ads y GA4: autorización, cuentas y acceso desde Claude o ChatGPT.</p>
        <Link className="btn btn-primary" to="/conexiones-google">Configurar conexiones</Link>
      </div></div>
      </div>

      <CompanySettingsModal
        open={companyModalOpen}
        onClose={() => {
          setCompanyModalOpen(false);
          setCompanyStatus(null);
        }}
        form={companyForm}
        setForm={setCompanyForm}
        status={companyStatus}
        saving={savingCompany}
        uploadingLogo={uploadingLogo}
        onSave={handleSaveCompany}
        onUploadLogo={handleUploadLogo}
        toAbsoluteUrl={toAbsoluteUrl}
      />

      <DolibarrSettingsModal
        open={dolibarrModalOpen}
        onClose={() => setDolibarrModalOpen(false)}
        alertVariant={alertVariant}
        status={doliStatus}
        lastSync={dolibarrLastSync}
        loading={loadingDolibarr}
        url={dolibarrUrl}
        setUrl={setDolibarrUrl}
        apiKey={dolibarrKey}
        setApiKey={setDolibarrKey}
        loaded={dolibarrLoaded}
        onConnect={handleDolibarrConnect}
      />

      <StripeSettingsModal
        open={stripeModalOpen}
        onClose={() => {
          setStripeModalOpen(false);
          setStripeStatus(null);
        }}
        alertVariant={alertVariant}
        status={stripeStatus}
        publishableKey={stripePublishableKey}
        setPublishableKey={setStripePublishableKey}
        secretKey={stripeSecretKey}
        setSecretKey={setStripeSecretKey}
        webhookSecret={stripeWebhookSecret}
        setWebhookSecret={setStripeWebhookSecret}
        hasSecretKey={stripeHasSecretKey}
        hasWebhookSecret={stripeHasWebhookSecret}
        loading={loadingStripe}
        onSave={handleStripeSave}
      />

      <EmailAccountsModal
        open={emailModalOpen}
        onClose={() => setEmailModalOpen(false)}
        alertVariant={alertVariant}
        status={emailStatus}
        loadingAccounts={loadingAccounts}
        accounts={emailAccounts}
        onNew={() => {
          openAccountEditorFromEmailModal(() => {
            resetEmailForm();
            setAccountModalOpen(true);
          });
        }}
        onEdit={(acc) => openAccountEditorFromEmailModal(() => handleEditAccount(acc))}
      />

      <CalendarSettingsModal
        open={calendarModalOpen}
        onClose={() => setCalendarModalOpen(false)}
        alertVariant={alertVariant}
        status={calendarStatus}
        config={calendarConfig}
        setConfig={setCalendarConfig}
        newCalendarId={newCalendarId}
        setNewCalendarId={setNewCalendarId}
        handleGoogleConnect={handleGoogleConnect}
        handleAddCalendarId={handleAddCalendarId}
        handleRemoveCalendarId={handleRemoveCalendarId}
        handleSaveCalendar={handleSaveCalendar}
      />

      <GoogleDriveSettingsModal
        open={driveModalOpen}
        onClose={() => setDriveModalOpen(false)}
        alertVariant={alertVariant}
        status={driveStatus}
        config={driveConfig}
        setConfig={setDriveConfig}
        loading={loadingDrive}
        saving={savingDrive}
        testing={testingDrive}
        onConnect={handleDriveConnect}
        onSave={handleSaveDrive}
        onTest={handleTestDrive}
      />

      <WhatsappSettingsModal
        open={whatsModalOpen}
        onClose={() => setWhatsModalOpen(false)}
        alertVariant={alertVariant}
        status={wabaStatus}
        handleConnect={handleWhatsAppConnect}
        loadingWhatsApp={loadingWhatsApp}
        wabaToken={wabaToken}
        setWabaToken={setWabaToken}
        phoneNumberId={phoneNumberId}
        setPhoneNumberId={setPhoneNumberId}
        wabaId={wabaId}
        setWabaId={setWabaId}
        wabaVerifyToken={wabaVerifyToken}
        setWabaVerifyToken={setWabaVerifyToken}
        autoReplyEnabled={autoReplyEnabled}
        setAutoReplyEnabled={setAutoReplyEnabled}
        autoReplyText={autoReplyText}
        setAutoReplyText={setAutoReplyText}
        autoReplyTemplateId={autoReplyTemplateId}
        setAutoReplyTemplateId={setAutoReplyTemplateId}
        autoReplyTemplateLang={autoReplyTemplateLang}
        setAutoReplyTemplateLang={setAutoReplyTemplateLang}
        autoReplyTemplateType={autoReplyTemplateType}
        setAutoReplyTemplateType={setAutoReplyTemplateType}
        whatsappTemplates={whatsappTemplates}
        onSaveAutoReply={handleSaveAutoReply}
        autoReplyOnceHours={autoReplyOnceHours}
        setAutoReplyOnceHours={setAutoReplyOnceHours}
        offHoursEnabled={offHoursEnabled}
        setOffHoursEnabled={setOffHoursEnabled}
        offHoursText={offHoursText}
        setOffHoursText={setOffHoursText}
        offHoursOnceHours={offHoursOnceHours}
        setOffHoursOnceHours={setOffHoursOnceHours}
        businessHours={businessHours}
        setBusinessHours={setBusinessHours}
        onSaveOffHours={handleSaveOffHours}
        aiGenerateDraft={aiGenerateDraft}
        setAiGenerateDraft={setAiGenerateDraft}
        aiAutoSend={aiAutoSend}
        setAiAutoSend={setAiAutoSend}
        onSaveAiConfig={handleSaveAiConfig}
      />

      <EmailAccountEditorModal
        open={accountModalOpen}
        onClose={closeAccountEditor}
        onSave={handleSaveAccount}
        saving={savingAccount}
        editingAccount={editingAccount}
        emailForm={emailForm}
        handleChange={handleEmailFormChange}
        setEmailForm={setEmailForm}
        signatureModules={signatureModules}
        signatureFormats={signatureFormats}
      />
    </>
  );
};

export default SettingsPage;
